import React from "react";
import { Link } from "react-router-dom";
import { useSiteConfig } from "@/contexts/SiteConfigContext";

export default function ForPhotographers() {
  const site = useSiteConfig();
  return (
    <div className="max-w-[1400px] mx-auto px-6 md:px-12 pt-16 pb-24" data-testid="for-photographers-page">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-16 items-center">
        <div>
          <div className="pm-slash mb-6 text-sm"><span>For Event Photographers</span></div>
          <h1 className="font-display text-5xl md:text-7xl uppercase leading-[0.95] tracking-tight">
            Get more <span className="pm-orange">exposure</span>.<br />
            Sell to riders in <span className="pm-orange">one place</span>.
          </h1>
          <p className="text-white/70 mt-6 max-w-lg font-condensed text-lg leading-relaxed">
            Instead of selling in separate places, help riders find every event photo in one shared marketplace. Your watermark, your prices, your payout.
          </p>

          <div className="mt-10 space-y-4">
            <Feature title="Automatic watermarks" body="Your company name is tiled across every preview. Original files stay clean for buyers." />
            <Feature title="Simple commission" body="You keep 85% by default. Configurable per photographer." />
            <Feature title="Direct payouts" body="Connect your Stripe account. Buyers pay, you get paid — automatically. (Coming soon)" />
            <Feature title="Bulk & FTP upload" body="Drop 100 photos at once, or pipe them straight from your FTP server." />
          </div>

          <div className="mt-10 flex flex-wrap gap-4">
            <Link to="/register/photographer" className="pm-btn" data-testid="cta-register-photographer">
              Apply to join
            </Link>
            <Link to="/login" className="pm-btn-outline" data-testid="cta-signin">
              Sign in
            </Link>
          </div>

          <p className="text-xs uppercase tracking-[0.2em] text-white/40 mt-6">
            All applications reviewed within 48 hours.
          </p>
        </div>

        <div className="relative">
          <div className="aspect-[4/5] bg-gradient-to-br from-[var(--pm-orange-20)] to-black border-2 border-[var(--pm-orange-40)] p-8 flex flex-col justify-between">
            <div>
              <p className="text-xs uppercase tracking-[0.3em] pm-orange font-semibold">The Deal</p>
              <p className="font-display text-6xl md:text-7xl mt-2 uppercase">
                85<span className="pm-orange">%</span>
              </p>
              <p className="text-sm uppercase tracking-[0.2em] text-white/70 mt-2 font-condensed">
                to the photographer
              </p>
            </div>
            <div className="tire-track opacity-60" />
            <div>
              <p className="text-xs uppercase tracking-[0.3em] text-white/40 font-semibold">Default commission</p>
              <p className="text-white/80 font-condensed mt-2">
                Buyers pay list price. {site.siteName} takes a flat 15% platform fee. Rate configurable per photographer.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function Feature({ title, body }) {
  return (
    <div className="flex gap-4">
      <div className="w-1 bg-[var(--pm-orange)] flex-shrink-0" />
      <div>
        <p className="font-display text-xl uppercase text-white">{title}</p>
        <p className="text-sm text-white/60 font-condensed">{body}</p>
      </div>
    </div>
  );
}
